import { render, staticRenderFns } from "./2_005_sf_sffk.vue?vue&type=template&id=ed8416ca"
import script from "./2_005_sf_sffk.vue?vue&type=script&lang=js"
export * from "./2_005_sf_sffk.vue?vue&type=script&lang=js"
import style0 from "./2_005_sf_sffk.vue?vue&type=style&index=0&id=ed8416ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports